<template>
    <div class="container-login100">
        <div class="row login-section">
            <div id="card-alert" class="card red-light" v-if="erro">
                <div class="card-content white-text">
                    <p>
                        <i class="material-icons">error</i> ERRO : {{ erroMensagem }}
                    </p>
                </div>
                <button type="button" class="close white-text" @click="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div id="login-page" class="row">

                <div class="col s6">

                    <form class="login-form" v-on:submit.prevent="login">
                    <div class="row no-margin">
                        <div class="input-field center">
                            <img src="static/assets/images/logo/logo-don-2cores.png" alt="" class="responsive-img valign profile-image-login">
                        </div>
                    </div>

                        <div class="row margin pt-3">
                            <div class="input-field col s12">
                                <i class="material-icons prefix pt-5">person_outline</i>
                                <input id="username" type="text" v-model="username">
                                <label for="username" :class="+checkValue(username)">Usuário</label>
                            </div>
                        </div>
                        <div class="row margin">
                            <div class="input-field col s12">
                                <i class="material-icons prefix pt-5">lock_outline</i>
                                <input id="password" type="password" v-model="password">
                                <label for="password" :class="checkValue(password)">Senha</label>
                            </div>
                        </div>
                        <div class="row margin">
                           <div class="col s6 offset-s6">
                                <router-link :to="{name:'solicitar_recuperar_senha'}">Esqueceu a senha?</router-link>
                           </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <button type="submit" class="btn waves-effect waves-light col s12 btn-login">Login</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="css">
    @import '../../../static/assets/css/custom/login.css';
</style>

<script>
    import Auth from '@/store/auth';
    import { login } from '@/helpers/api';

    export default {
        data: () => ({
            username: '',
            password: '',
            erro: false,
            erroMensagem: ''
        }),
        created() {
            $('html').addClass('login-page');
            $('body').addClass('login-page');
        },
        methods: {
            close(){
                this.erro = false;
            },
            login() {
                let auth = true;
                let self = this;
                if (! this.username || ! this.password) {
                    this.erro = true;
                    this.erroMensagem = 'Preencha usuário e senha.';
                    auth = false;
                    return false;
                }

                login(this.username, this.password).then(async  (response) => {

                    await Auth.set(response.data.token, response.data.usuario_id, response.data.usuario);

                    this.$router.push('/');

                }).catch(function () {
                    self.erro = true;
                    self.erroMensagem = 'Usuário ou senha incorreto.';
                    return false;
                });
            },
            checkValue(value) {
                if (value !== '') {
                    return 'active';
                }
                return '';
            },
        }
    }

</script>
<style scoped>
.center, .center-align {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue